<template>
    <div class="rm-files__footer">
        <button v-if="recept && recept.name && recept.user_id == user.id" class="room__delete r-button" @click="deleteRecept">Удалить</button>

        <label v-if="(user.doctor || user.clinic) && !recept.name" class="t-attach">
            <input type="file" @change="upload" ref="recept_file" class="t-attach__input">
            <span class="t-attach__text">Прикрепить</span>
        </label>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';

    export default {
        name: 'ReceptUpload',
        computed: {
            ...mapState('recept', [
                'recept',
            ]),
            ...mapState(['user']),
        },
        methods: {
            ...mapActions('recept', [
                'postRecept',
                'deleteRecept'
            ]),
            upload($event) {
                if (!$event.target.files.length) {
                    return false;
                }

                if ($event.target.files[0].size / (1024 * 1024) > 10) {
                    return ErrorAlert.$emit('errorMessage', 'Максимальный размер файла: 10 МБ');
                }

                let formData = new FormData();

                formData.append('file', this.$refs.recept_file.files[0]);

                this.postRecept(formData);
            }
        }
    }
</script>
